﻿import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { SecurityService } from '../services/security.service';
@Directive({
    selector: '[hasRole]'
})
export class HasRoleDirective {
    private el: HTMLElement;
    @Input() set hasRole(claim: any) {
        if (this.hasSelectedClaim(claim))
            this.viewContainer.createEmbeddedView(this.templateRef)
        else
            this.viewContainer.clear();
    }

    constructor(private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        private _securityService: SecurityService) { }

    hasSelectedClaim(roleName: any): boolean {
        let ret: boolean = false;

        if (typeof roleName === "string") {
            ret = this._securityService.hasRole(roleName);
        }
        else {
            let roles: string[] = roleName;
            if (roles) {
                for (let index = 0; index < roles.length; index++) {
                    ret = this._securityService.hasRole(roles[index]);
                    if (ret) {
                        break;
                    }
                }
            }
        }

        return ret;
    }
}
